import React from 'react';
import { cn } from '@/utils';
import { ISortConfig } from './Table.types';

interface SortIconProps {
  /** Current sort direction */
  direction?: ISortConfig['direction'];
  /** Additional CSS classes */
  className?: string;
}

/**
 * SortIcon Component
 *
 * A dual-arrow icon showing sort state for table headers.
 * Based on the Figma design with up/down arrow indicators.
 */
export const SortIcon: React.FC<SortIconProps> = ({ direction, className }) => {
  return (
    <div
      className={cn(
        'flex flex-shrink-0',
        'flex-col items-center justify-center',
        'gap-y-0.5',
        'h-4 w-4',
        'relative',
        className,
      )}
    >
      {/* Up Arrow */}
      <div className="flex items-center justify-center">
        <svg
          width="14.67"
          height="8"
          viewBox="0 0 14.67 8"
          className={cn(
            'h-2 w-[14.67px]',
            direction === 'asc' ? 'text-brand-primary' : 'text-neutral-gray-800',
          )}
        >
          <path d="M7.335 0L14.67 8H0L7.335 0Z" fill="currentColor" />
        </svg>
      </div>

      {/* Down Arrow */}
      <div className="flex items-center justify-center">
        <svg
          width="14.67"
          height="8"
          viewBox="0 0 14.67 8"
          className={cn(
            'h-2 w-[14.67px] rotate-180',
            direction === 'desc' ? 'text-brand-primary' : 'text-neutral-gray-800',
          )}
        >
          <path d="M7.335 0L14.67 8H0L7.335 0Z" fill="currentColor" />
        </svg>
      </div>
    </div>
  );
};

SortIcon.displayName = 'SortIcon';
